export const USER_TYPE_CODE = {
  REGULAR: "regular",
  SUPERVISOR: "supervisor",
} as const;

export type UserTypeCode = (typeof USER_TYPE_CODE)[keyof typeof USER_TYPE_CODE];

export const USER_DEPARTMENT_CODE = {
  ALL: "all",
  PACKAGING: "packaging",
  PRODUCTION: "production",
  RECEIVING: "receiving",
  SHIPPING: "shipping",
  ORDERS: "orders",
} as const;

export type UserDepartmentCode =
  (typeof USER_DEPARTMENT_CODE)[keyof typeof USER_DEPARTMENT_CODE];

export const USER_DEPARTMENT_OPTIONS: {
  value: UserDepartmentCode;
  label: string;
}[] = [
  { value: USER_DEPARTMENT_CODE.ALL, label: "All" },
  { value: USER_DEPARTMENT_CODE.PACKAGING, label: "Packaging" },
  { value: USER_DEPARTMENT_CODE.PRODUCTION, label: "Production" },
  { value: USER_DEPARTMENT_CODE.RECEIVING, label: "Receiving" },
  { value: USER_DEPARTMENT_CODE.SHIPPING, label: "Shipping" },
  { value: USER_DEPARTMENT_CODE.ORDERS, label: "Orders" },
];

export const USER_EMPLOYEE_TYPE_OPTIONS: {
  value: UserTypeCode;
  label: string;
}[] = [
  { value: USER_TYPE_CODE.REGULAR, label: "Regular" },
  { value: USER_TYPE_CODE.SUPERVISOR, label: "Supervisor" },
];
